export default __webpack_public_path__ + "static/media/img-v3-launch-mobile-2.8cefc0a6.png";